import React from 'react';
import {
  CardContainer,
  CardContent,
  CardIcon,
  CardTitle,
  CardSubtitle,
  CardValue,
  SkeletonCard,
  SkeletonTitle,
  SkeletonValue,
  SkeletonIcon,
} from './styles';

export const StatusCard = ({
  title,
  subtitle,
  subTitleColor,
  value,
  icon,
  color,
  loading = false,
  styleContainer,
}) => {
  if (loading) {
    return (
      <SkeletonCard>
        <CardContent>
          <SkeletonTitle className="skeleton" />
          <SkeletonValue className="skeleton" />
        </CardContent>
        <SkeletonIcon className="skeleton" />
      </SkeletonCard>
    );
  }

  return (
    <CardContainer style={styleContainer}>
      <CardContent>
        <CardTitle>{title}</CardTitle>
        <CardValue color={color}>{value}</CardValue>
        {subtitle && <CardSubtitle style={{ color: subTitleColor }}>{subtitle}</CardSubtitle>}
      </CardContent>
      <CardIcon color={color}>
        <i className="material-icons">{icon}</i>
      </CardIcon>
    </CardContainer>
  );
};
